import React from "react";
import { Amplify } from "aws-amplify";
import awsconfig from "./aws-exports";

// scss
import "./assets/scss/theme.scss";

//Route
import Routes from "./routes";

const App = () => {
  document.title = "Invoice";

  return <Routes />;
};

export default App;
